/**
 * Handle Parallax
 */

import { $window } from '../utils/globals.js';

const handleParallax = () => {
	$window.on('load scroll', function() {
		const $jsParallax = $('.js-parallax');

		$jsParallax.each(function() {
			const $this = $(this);
			let parallaxOffset = ( $window.scrollTop() - $this.offset().top ) * .3;

			if ( $this.offset().top <= $window.scrollTop() + $window.height() ) {
				$this.css({
					'-webkit-background-position': `center ${parallaxOffset}px`,
					'-moz-background-position': `center ${parallaxOffset}px`,
					'-ms-background-position': `center ${parallaxOffset}px`,
					'-o-background-position': `center ${parallaxOffset}px`,
					'background-position': `center ${parallaxOffset}px`
				});
			}
		});
	});
}

handleParallax();
